import { AddCartLinesLoaderActions } from "@dana/Store/Data/AddCartLinesLoader/Reducers/AddCartLinesLoaderReducer";
import { ApiHandler, createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { DispatchProp } from "react-redux";

type HandlerType = ApiHandler<{isLoading:boolean},
    DispatchProp<AddCartLinesLoaderActions>
>;

export const AddCartLinesLoaderFlag: HandlerType = props => {

    props.dispatch({
        type: "AddCartLinesLoader/IsLoading",
        isLoading: props.parameter.isLoading,
    } as any);
};

export const chain = [AddCartLinesLoaderFlag];

const setAddCartLinesLoaderFlag = createHandlerChainRunner(chain, "SetAddCartLinesLoaderFlag");
export default setAddCartLinesLoaderFlag;